module.exports = __webpack_public_path__ + "img/trucking_wei.68043c11.png";